define('models/PaymentModeModel',[
    'underscore','backbone','ObjectModel','LocalStorage','app', 'formatPrice',
    'models/EdenredDataModel',
],function (
        _,Backbone,ObjectModel,LocalStorage,app, formatPrice,
        EdenredDataModel
    ) {
    //
    // Model PaymentGroup
    //

    var PROVIDER_REQUIRE_NOTHING = 0;
    var PROVIDER_REQUIRE_RETURN_MONEY = 1;
    var PROVIDER_REQUIRE_OGONE_ADD_CARD = 20;
    var PROVIDER_REQUIRE_OGONE_DIRECT_FORM = 50;

    var PROVIDER_REQUIRE_OGONE_BRAND = 22;
    var PROVIDER_REQUIRE_OGONE_CVC = 21;
    var PROVIDER_REQUIRE_OGONE_VALID_BRAND = 22;
    var PROVIDER_REQUIRE_PRIMARY_ADDRESS = 30;
    var PROVIDER_REQUIRE_SIMPLE_PAYMENT = 40;
    var selectOptionTemplate = _.template('<option value="<%= value %>" <%= disabled?\'disabled\':\'\'%> data-id="<%= id %>" data-content="<%= content %>" <%= attr %>><%= name %></option>');

    var CASH_ON_DELIVERY_PROVIDER = 'CashOnDeliveryProvider';
    var OGONE_PROVIDER = 'OgoneProvider';
    var OGONE_DIRECT_PROVIDER = "OgoneDirectProvider";
    var PAYTABS_PROVIDER = 'PaytabsProvider';
    var ZERO_PROVIDER = 'ZeroProvider';

    function formatCardName(rawCardName,shortX){
        return (rawCardName||'').replace(shortX || app.isMobile() ? /X+/g : /X{3,4}/g,'•••• ').replace(/([\d]{4})/g, '$1 ').trim();
    }
    function formatExpire(card){
        var expire = card.expiryDate || '';
        if (expire) expire = app.t('expire en %s', 'Checkout', expire.replace(/^(\d\d)(\d\d)$/, "\$1/\$2"));
        return expire;
    }

    var PaymentGroupModelPrototype = {

        name:'PaymentGroupModel',
        route:'apiPaymentGroupModel',
        idAttribute:'id_payment_mode',

        defaults:function(){return {
            vae:true,
            vad:true,
            pictures:[],
            params:{},
        }},

        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
            //
            model.resetOptions();
        },

        getCards:function(excludeTemporary){
            var model = this,
                id_payment_mode = model.id;
            var cards = app.getCustomer().getCards();
            var brands = app.getPaymentBrands();
            var availableBrands = model.getParam('brand');
            var cardsMap = [];
            _(cards).each(function(card){
                var expire = formatExpire(card);
                var id_card = card.id_card,
                    value = id_payment_mode+':'+id_card,
                    cardNum = formatCardName(card.cardNum,true),
                    cbBrand = card.brand,
                    warnings = [],
                    brand = brands.findWhere({brand:cbBrand, id_payment_mode:id_payment_mode}),
                    disabled = true,
                    pict = '',
                    cardLabel = '<span data-cs-mask>'+cardNum+'</span>',
                    cardParams = {
                        directlink:1,
                        id_card:id_card
                    };
                if(!!expire){
                    cardLabel += '<small data-cs-mask>'+expire+'</small>';
                }

                if(brand){
                    pict = brand.getPictureUrl();
                    disabled = !_.contains(availableBrands,(brand.id));
                    // on ignore les cartes si il est soudainement devenu non-directlink...
                    if(!brand.get('directlink')){
                        return;
                    }
                }
                if(disabled){
                    warnings.push(model.getParam('unavailable_card'));
                }
                if(card.temporary && excludeTemporary) return;
                cardsMap.push({
                    id: value,
                    id_payment_mode: id_payment_mode,
                    value: value,
                    params: cardParams,
                    content: cardLabel,
                    name: cardLabel,
                    brand:cbBrand,
                    id_card:id_card,
                    disabled:disabled,
                    warnings:warnings,
                    pict: pict,
                })
            });
            return _(cardsMap);
        },

        getSelectDatas:function() {
            // retourne les options d'un mode de paiement
            // le cas simple, c'est une option par mode
            // pour Ogone, c'est en plus la liste des cartes enrolées
            var model = this,
                id_payment_mode = model.id,
                provider = model.get('provider'),
                cart = app.getCart(),
                usedPaymentMode = cart.getUsedPaymentMode(),
                disableDetails = model.getDisableDetails(),
                disabled = disableDetails.length > 0,
                isSelected = !!usedPaymentMode && (usedPaymentMode.id === id_payment_mode),
                name = model.get('name'),
                baseOption = {
                    id: id_payment_mode,
                    id_payment_mode: id_payment_mode,
                    value: id_payment_mode,
                    params:{},
                    content: model.getSelectOptionContent(disableDetails),
                    warnings: disableDetails,
                    name: name || "Invalide",
                    disabled: disabled,
                    selected: isSelected,
                    pict:false,
                    deletable:false,
                    attr: '', // deprecated
                },
                selectDatas = [];
            if (provider === OGONE_PROVIDER || provider === OGONE_DIRECT_PROVIDER)
            {
                //var filterBrandIds = brands.pluck('brand');
                var isOgoneDirect = provider === OGONE_DIRECT_PROVIDER;
                var cards = model.getCards(true),
                    brandsStorable = model.getBrands('Y'),
                    hasSomeBrandStorable = brandsStorable.length > 0,
                    id_card_selected = isSelected ? usedPaymentMode.getOption('id_card',false,true) : false;
                if(hasSomeBrandStorable) {
                    cards.each(function (card) {
                        // TODO
                        var id_card = card.id_card,
                            cardDisabled = card.disabled || disabled,
                            isCardSelected = isSelected && id_card_selected === id_card;
                        if (isCardSelected) {
                            baseOption.selected = false;
                            isSelected = false;
                        }
                        var cardSelectData = _.defaults({
                            disabled: cardDisabled,
                            selected: isCardSelected,
                            deletable: true,
                            attr: ' data-card="' + id_card + '"', // deprecated
                        }, card);
                        selectDatas.push(cardSelectData);
                    });
                }
                //
                if(isOgoneDirect){
                    var brandsNotStorable = model.getBrands('N');
                    if(hasSomeBrandStorable){
                        var brandsPictures = brandsStorable.map(function(brandModel){
                            return brandModel.getPictureUrl();
                        });
                        console.log("brandsPictures",brandsPictures);
                        selectDatas.push(_.defaults({
                            id: id_payment_mode + ':tokenization',
                            value: id_payment_mode + ':tokenization',
                            name: model.getParam('pay_with_tokenization_label'),
                            pictures: brandsPictures,
                            params: {
                                selected: false,
                            },
                        },baseOption));
                    }
                    if(brandsNotStorable.length){
                        brandsNotStorable.each(function(brandModel){
                            var cbBrand = brandModel.get('brand')
                            var id = id_payment_mode + ':'+cbBrand
                            var name = brandModel.get('name');
                            var pay_without_tokenization_label= model.getParam('pay_without_tokenization_label')
                            var picture= brandModel.getPictureUrl();
                            var label = name;
                            if(pay_without_tokenization_label){
                                label = pay_without_tokenization_label.replace('%s', name);
                            }
                            selectDatas.push(_.defaults({
                                id: id,
                                value: id,
                                name: label,
                                pict:picture,
                                params: {
                                    directlink: 0,
                                    cbBrand: cbBrand,
                                    selected: false,
                                },
                            },baseOption));
                        });

                    }
                }else {
                    var cardNotStorePermanentlyValue = id_payment_mode + ':p',
                        notStoreSelected = isSelected ? (model.getOption('storepermently', false, true) === 'N') : false,
                        name = model.getParam(hasSomeBrandStorable ?
                            'pay_without_save_label' : //'Payer sans enregistrer votre carte',
                            'pay_without_save_only_label' //'Payer avec votre carte',
                        ),
                        params = {
                            storepermently: 'N',
                            brands_filter: '*',
                            selected: notStoreSelected,
                        },
                        cardNotStorePermanently = _.defaults({
                            id: cardNotStorePermanentlyValue,
                            value: cardNotStorePermanentlyValue,
                            name: name,
                            params: params,
                        }, baseOption);
                    baseOption.name = model.getParam('pay_and_save_label');
                    baseOption.selected = isSelected && !notStoreSelected;
                    baseOption.params = {
                        storepermently: 'Y',
                        brands_filter: 'Y',
                    };
                    if (hasSomeBrandStorable) {
                        // on affiche le bouton d'enregistrement, uniquement si il y a des brands qui le permettent
                        selectDatas.push(baseOption);
                    }
                    selectDatas.push(cardNotStorePermanently);
                }
            }
            else{
                selectDatas.push(baseOption);
            }
            return _(selectDatas);
        },
        getSelectOptions:function(){
            var selectDatas = this.getSelectDatas();
            return selectDatas.map(function(o){
                return selectOptionTemplate(o);
            }).join('');
        },

        load3DSv2Params:function(){
            // Ogone 3DS v2 extra params
            var navigator = window.navigator,
                screen = window.screen,
                extraParams = {};
            //
            function setBrowserInfo(name,value){
                extraParams['browser'+name] = value;
            }
            try {
                setBrowserInfo('JavaEnabled', navigator.javaEnabled() || false);
                setBrowserInfo('TimeZone', new Date().getTimezoneOffset());
                setBrowserInfo('ColorDepth', screen.colorDepth);
                setBrowserInfo('Language', navigator.language);
                setBrowserInfo('ScreenWidth', screen.width);
                setBrowserInfo('ScreenHeight', screen.height);
                setBrowserInfo('UserAgent', navigator.userAgent);
            }catch(err){
            }
            this.setOption('extraParams',extraParams)
        },

        getDisableDetails:function(){
            var details = [],
                provider = this.get("provider"),
                EdenredIsSelected = EdenredDataModel.isSelected(),
                requireAltPM = EdenredDataModel.requireAltPM(),
                can_use_in_multi_payment = this.getParam('can_use_in_multi_payment');
            if( EdenredIsSelected && requireAltPM && !can_use_in_multi_payment){
                details.push(app.t('Il est impossible d’utiliser ce mode de paiement en complément d’un titre restaurant','Checkout'));
            }
            if(!provider){
                details.push(app.t('Ce mode de paiement n’est pas disponible','Checkout'));
            }
            if( this.hasProductRestriction()){
                details.push(this.getRestrictionMessage());
            }
            return details;
        },

        getAddBrandTitle:function(){
            var model = this,
                storepermently = this.getOption('storepermently',null,true),
                param = storepermently === 'Y' ? 'pay_and_save_label' : 'pay_without_save_label';
            return model.getParam(param);//.t(title,'Checkout');
        },

        getSelectOptionContent:function(disableDetails){
            var model = this, html, name = html = model.get('name'), picture = model.get('picture'), pictureUrl;

            if(picture && picture[0]){
                pictureUrl = UrlFactory.getUrlPicture(picture[0].id_object_picture,picture[0].class,'100x60','payment','png');
                if(pictureUrl){
                    html = '<img class=\'payment-icon\' src=\''+pictureUrl+'\' /> '+name;
                }
            }
            if(disableDetails.length){
                html += '<div class=\'payment-mode__selection__alert\'><p>'+disableDetails.join('</p><p>')+'</p></div>';
            }
            return html;
        },

        resetOptions:function(paramsDefaults){
            this.set('options',{id_payment_mode:this.id,params:_.defaults({},paramsDefaults)});
        },

        getOptions:function(){
            return this.get('options');
        },

        getOption:function(propName,defaultValue,isParams){
            var oo = this.getOptions(),
                o = (isParams ? oo.params:oo)[propName];
            if(_.isUndefined(o)) return defaultValue;
            return o;
        },

        setOption:function(propName,propValue,isParams){
            var oo = this.getOptions(),
                v = (isParams ? oo.params : oo)[propName] = propValue;
            return v;
        },

        setOptions:function(params,isParams){
            var oo = this.getOptions();
            _(params).each(function(v,k){
                (isParams ? oo.params : oo)[k] = v;
            });
        },
        getPictureUrl:function(){
            // TODO
            var model = this,
                pictureUrl = '',
                pictures = model.get('pictures'),
                picture;
            if(pictures.length){
                picture = pictures[0];
                pictureUrl = app.getPictureUrl(picture.id_object_picture,'paymentmode','120x72','PNG',model.id);
            }
            return pictureUrl;
        },

        getDesc:function(){
            var model = this,
                provider = model.get('provider'),
                desc_primary = model.get('name') || "Invalide",
                id_payment_mode = model.id,
                desc_secondary = '',
                dark = false,
                pict = model.getPictureUrl(),
                change_label = app.t('Modifier', 'UI'),
                disabled = false,
                warnings = model.getDisableDetails();
            ;
            switch(provider){
                default :
                    break;
                case OGONE_DIRECT_PROVIDER:
                case OGONE_PROVIDER:
                    var isOgoneDirect = provider === OGONE_DIRECT_PROVIDER;
                    var id_card = model.getOption('id_card',false,true),
                        directlink = model.getOption('directlink',null,true),
                        cbBrand = model.getOption('cbBrand',null,true),
                        card = app.getCustomer().getCard(id_card),
                        brands = app.getPaymentBrands(),
                        brand,brandName;
                    if(id_card && card){
                        var expire = formatExpire(card),
                            cardNum = formatCardName(card.cardNum);
                        cbBrand = card.brand;
                        desc_secondary = '<span data-cs-mask>'+cardNum+' '+expire+'</span>';
                    }else if(directlink===0){
                        desc_secondary = model.getParam('you_will_be_redirect');
                        console.log('cbBrand',cbBrand)
                    }
                    if(cbBrand){
                        brand = brands.findWhere({brand:cbBrand, id_payment_mode:id_payment_mode});
                        if(brand){
                            brandName = brand ? brand.get('name') : cbBrand;
                            desc_primary = brandName;
                            pict = brand.getPictureUrl();
                            if(!_(model.getParam('brand') || []).contains(brand.id)){
                                warnings.push(model.getParam('unavailable_card'));
                            }
                        }
                    }
                    break;
                case CASH_ON_DELIVERY_PROVIDER:
                    var return_money = model.getOption('return_money',''),
                        param_key = 'return_money_vae_message';
                    if(!!return_money){
                        param_key =  'return_money_vad_message';
                    }else if(app.getCart().isVAD()){
                        param_key = 'return_money_0_vad_message';
                    }
                    desc_secondary = (model.getParam(param_key)||'').replace('%s',formatPrice(return_money));
                    break;
                case ZERO_PROVIDER:
                    disabled = true;
                    desc_primary = model.getParam('desc_primary');
                    desc_secondary = model.getParam('desc_secondary');
                    change_label = '';
                    dark = true;
                    break;
            }
            return {
                desc_primary: desc_primary,
                desc_secondary: desc_secondary,
                pict: pict,
                change_label: change_label,
                warnings: warnings,
                dark: dark,
                disabled: disabled,
            };
        },

        getRequirement:function(){
            var model = this,
                cart = app.getCart(),
                provider = model.get('provider'),
                id_payment_mode = model.id,
                requirement = PROVIDER_REQUIRE_NOTHING;
            switch(provider){
                case OGONE_PROVIDER:
                case OGONE_DIRECT_PROVIDER:
                    var id_card = model.getOption('id_card',false,true);
                    var isOgoneDirect = provider === OGONE_DIRECT_PROVIDER;
                    var cvc = model.getOption('cvc',false,true),
                        validationCVC = /^[0-9]{3,4}$/.test(cvc),
                        cartRequireCVC = cart.requireCVC(),
                        directlink = model.getOption('directlink',false,true),
                    cbBrand = model.getOption('cbBrand',null,true);
                    model.load3DSv2Params();
                    if(directlink === 0){
                        // noop
                    }else if(!id_card){
                        // si on a pas de carte, on demande à l'ajouter
                        if(isOgoneDirect){
                            requirement = PROVIDER_REQUIRE_OGONE_ADD_CARD;
                        }else if(_.isNull(cbBrand)){
                            // permet d'afficher toutes les marques quand on n'enregistre pas la carte
                            var brands = model.getBrands(),
                                brandSize = brands.size();
                            if(brandSize===1){
                                var brand = brands.first();
                                model.setOption('cbBrand',brand.get('brand'),true);
                                if(brand.directlink){
                                    // si il n'y a qu'une seule marque disponible, on la sélectionne
                                    // et qu'elle est en direct link
                                    requirement = PROVIDER_REQUIRE_OGONE_ADD_CARD;
                                }
                            }else{
                                console.log("isOgoneDirect",isOgoneDirect);
                                requirement = PROVIDER_REQUIRE_OGONE_BRAND
                            }
                        }else{
                            requirement = PROVIDER_REQUIRE_OGONE_ADD_CARD;
                        }
                    }else{
                        var card = app.getCustomer().getCard(id_card);
                        if(!card || !card.brand){
                            if(isOgoneDirect){
                                requirement = PROVIDER_REQUIRE_OGONE_DIRECT_FORM;
                            }else {
                                requirement = PROVIDER_REQUIRE_OGONE_ADD_CARD;
                            }
                        }else if(!model.getBrands('Y').findWhere({brand:card.brand, id_payment_mode:id_payment_mode})){
                            // si la brand n'est pas disponible
                            requirement = PROVIDER_REQUIRE_OGONE_VALID_BRAND;
                        }else if(!validationCVC){
                            if(isOgoneDirect) {
                                validationCVC = true;
                            }else if(cartRequireCVC || !card.used){
                                // validation formelle du CVC
                                // si les règles panier ou que la carte n'a jamais été utilisée, on demande le CVC
                                requirement = PROVIDER_REQUIRE_OGONE_CVC;
                            }
                        }
                    }
                    break;
                case CASH_ON_DELIVERY_PROVIDER:
                    // le champs monnaie à prévoir est uniquement en VAD
                    var return_money = model.getOption('return_money');
                    if(cart.isVAD() && !(return_money >= 0)){
                        requirement = PROVIDER_REQUIRE_RETURN_MONEY;
                    }
                    break;
                case PAYTABS_PROVIDER:
                    var primaryAddress = app.getCustomer().getPrimaryAddress();
                    // si on on est Click & Collect et qu'on a pas de primary adress, on l'exige
                    if(cart.isVAE() && !primaryAddress){
                        requirement = PROVIDER_REQUIRE_PRIMARY_ADDRESS;
                    }
                    break;
                case ZERO_PROVIDER:
                default:
            }

            // multiple paiement with Edenred
            var canUseInMultiPayment = model.canUseInMultiPayment(),
                multiple_payment_available_amount = undefined,
                multiple_id_payment_mode = undefined,
                edenredPaymentMode = EdenredDataModel.getPM(),
                edenredPaymentModeId = edenredPaymentMode ? edenredPaymentMode.id : 0,
                isPrimaryEdenred = edenredPaymentModeId === model.id,
                edenredIsActive = EdenredDataModel.isActive(),
                use_multiple_payment = canUseInMultiPayment && edenredIsActive && !isPrimaryEdenred;
            if(use_multiple_payment){
                multiple_payment_available_amount = EdenredDataModel.getUsedAvailable();
                multiple_id_payment_mode = edenredPaymentModeId;
                model.setOption('use_multiple_payment',use_multiple_payment);
                model.setOption('multiple_payment_available_amount',multiple_payment_available_amount);
                model.setOption('multiple_id_payment_mode',multiple_id_payment_mode);
            }else if(edenredIsActive && requirement === 0 && !isPrimaryEdenred){
                // cas ou le paiement ne supporte pas le paiement multiple, mais que edenred a été ajouté entre temps.
                requirement = PROVIDER_REQUIRE_SIMPLE_PAYMENT;
            }else{
                var options = model.getOptions();
                delete options.use_multiple_payment;
                delete options.multiple_payment_available_amount;
                delete options.multiple_id_payment_mode;
            }


            return requirement;
        },

        isAvailable:function(isVAE){
              return this.get(isVAE ? 'vae':'vad');
        },

        isZero:function(){
            return this.get('provider') === ZERO_PROVIDER;
        },

        getParam:function(key){
            return this.get('params')[key];
        },

        getBrands:function(storepermently){
            var paymentMode = this,
                idBrands = paymentMode.getParam('brand'),
                brands = app.getPaymentBrands().byIds(idBrands, paymentMode.id);
            if(_.isUndefined(storepermently)){
                var brands_filter = paymentMode.getOption('brands_filter',null,true);
                if(brands_filter === 'Y') storepermently = 'Y';
            }
            if(storepermently === 'Y' || storepermently === 'N'){
                var filterTrue = storepermently === 'Y';
                // filter only directlink brands
                var toRemove = [];
                brands.each(function(b,i){
                    if((!!b.get('directlink')) !== filterTrue){
                        toRemove.push(b);
                    }
                });
                brands.remove(toRemove);
            }
            return brands;
        },

        canUseInMultiPayment:function(){
            return this.getParam('can_use_in_multi_payment');
        },

        validateBeforeSubmit:function(callback){
            var requirement = this.getRequirement();
            if(requirement !== PROVIDER_REQUIRE_NOTHING &&  requirement !== PROVIDER_REQUIRE_OGONE_DIRECT_FORM){
                callback();
                app.trigger('paymentModeRequirement',this,requirement);
                return false;
            }
            return true;
        },

        getRestrictionMessage:function(){
            var cart = app.getCart();
            var paymentRestrictions = cart.get('payment_restrictions'),
                restrictions = paymentRestrictions[this.id],
                message = "", args;
            if(restrictions){
                args = app.getProduct(restrictions[0]).getName();
                if(restrictions.length>1){
                    message = "Plusieurs produits présents dans votre panier ne sont pas éligibles avec ce mode de paiment (%s, …)";
                }else if(restrictions){
                    message = "%s n’est pas éligible avec ce mode de paiment";
                }
            }
            if(EdenredDataModel.isActive() && !this.canUseInMultiPayment()){
                message += " Indisponible avec Edenred."
            }
            return app.t(message,'Checkout',args);
        },

        hasProductRestriction:function(){
            // TODO
            // teste si le mode de paiment à un restriction lié à un produit (du panier)
            var cart = app.getCart();
            var model = this,
                hasRestriction,
                paymentRestrictions = cart.get('payment_restrictions'),
                restriction = paymentRestrictions[model.id];

            hasRestriction = !_.isUndefined(restriction);

            return hasRestriction;
        }
    };

    var PaymentGroupModel = ObjectModel.extend(LocalStorage).extend(PaymentGroupModelPrototype);

    return PaymentGroupModel;
});
